import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft, ChevronRight, Flame, ArrowRight } from 'lucide-react';
import axios from 'axios';
import { PLACEHOLDER_IMG, handleImgError } from '@/lib/imagePlaceholder';

const API = window.location.origin + '/api';

export default function DealsCarousel() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const scrollerRef = useRef(null);

  useEffect(() => {
    axios.get(`${API}/products`, { params: { discount: true } })
      .then(r => {
        // Top deals: sorted by discount % desc
        const sorted = [...r.data].sort((a, b) => (b.discount_percent || 0) - (a.discount_percent || 0));
        setProducts(sorted.slice(0, 14));
      })
      .catch(err => console.error('Failed to load deals:', err.message))
      .finally(() => setLoading(false));
  }, []);

  const scroll = (dir) => {
    const el = scrollerRef.current;
    if (!el) return;
    el.scrollBy({ left: dir * 260, behavior: 'smooth' });
  };

  if (loading) return null;
  if (products.length === 0) return null;

  return (
    <div className="home-section" data-testid="deals-section">
      <div className="home-section-header">
        <h2 className="section-heading" style={{ display: 'flex', alignItems: 'center', gap: 8, margin: 0 }}>
          <Flame size={20} style={{ color: '#DC2626' }} /> Today's Deals
        </h2>
        <Link to="/category/discounts" className="section-view-all" data-testid="view-all-deals">
          See all <ArrowRight size={13} />
        </Link>
      </div>

      <div className="deals-wrap">
        <button className="deals-arrow deals-arrow-prev" onClick={() => scroll(-1)} aria-label="Scroll left" data-testid="deals-prev">
          <ChevronLeft size={18} />
        </button>
        <div className="deals-scroller" ref={scrollerRef} data-testid="deals-scroller">
          {products.map(p => {
            const final = p.is_weighted
              ? p.price_per_kg
              : p.price * (1 - (p.discount_percent || 0) / 100);
            return (
              <Link
                key={p.id}
                to={`/category/${p.category_slug}`}
                className="deal-card"
                data-testid={`deal-card-${p.id}`}
              >
                <div className="deal-img-wrap">
                  {p.discount_percent > 0 && (
                    <span className="deal-badge" data-testid={`deal-badge-${p.id}`}>
                      -{Math.round(p.discount_percent)}%
                    </span>
                  )}
                  <img
                    src={p.image_url || PLACEHOLDER_IMG}
                    alt={p.name}
                    loading="lazy"
                    onError={handleImgError}
                  />
                </div>
                <div className="deal-info">
                  <div className="deal-name">{p.name}</div>
                  <div className="deal-store">{p.supermarket_name}</div>
                  <div className="deal-price-row">
                    <span className="deal-price">{final.toFixed(2)} <small>PGK{p.is_weighted ? '/kg' : ''}</small></span>
                    {!p.is_weighted && p.discount_percent > 0 && (
                      <span className="deal-orig">{p.price.toFixed(2)}</span>
                    )}
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
        <button className="deals-arrow deals-arrow-next" onClick={() => scroll(1)} aria-label="Scroll right" data-testid="deals-next">
          <ChevronRight size={18} />
        </button>
      </div>
    </div>
  );
}
